
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iZn0V", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0a0faf05e978b3d2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $0a0faf05e978b3d2$export$2e2bcd8739ae039 = {
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Drevet af Atlassian Intelligence',
    'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Drevet af AI',
    'fabric.editor.ai.commandPalette.footer.disclaimerText': "Indholdet er baseret p\xe5 dine tilladelser, og kvaliteten kan variere",
    'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'Indholdskvaliteten kan variere',
    'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': "Bruger kunstig intelligens. Bekr\xe6ft resultater.",
    'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Information',
    'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
    'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Medtag viden fra den aktuelle side',
    'fabric.editor.ai.commandPalette.promptForm.logo': 'Atlassian Intelligence-logo',
    'fabric.editor.ai.components.backIconButton.backLabel': 'Tilbage',
    'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Annuller',
    'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
    'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Annuller',
    'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Annuller',
    'fabric.editor.ai.components.feedbackForm.badResponse': "D\xe5rligt svar",
    'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Feedback sendt',
    'fabric.editor.ai.components.feedbackForm.goodResponse': 'Godt svar',
    'fabric.editor.ai.config.item.action.continueFromLatestResponse': "Forts\xe6t fra sidste svar",
    'fabric.editor.ai.config.item.action.copyResponse': "Kopi\xe9r",
    'fabric.editor.ai.config.item.action.responseCopied': 'Kopieret!',
    'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Kopieret til udklipsholder',
    'fabric.editor.ai.config.item.action.retryPrompt': "Pr\xf8v igen",
    'fabric.editor.ai.experience-application.documentInsertError': "Vi har problemer med at inds\xe6tte svaret. Luk dialogboksen, og pr\xf8v igen.",
    'fabric.editor.ai.experience-application.tokenLimitExceeded': "Vi kunne ikke f\xe5 et svar. Prompten eller svaret var over gr\xe6nsen for denne anmodning. Luk dialogboksen, og pr\xf8v igen.",
    'fabric.editor.ai.experience.apiError': "Vi kunne ikke f\xe5 svar. Pr\xf8v igen.",
    'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
    'fabric.editor.ai.experience.commandPaletteV2Placeholder': "Fort\xe6l AI, hvad der nu skal g\xf8res\xa0...",
    'fabric.editor.ai.experience.inputTooShortError': "Indholdet er for kort til at opsummere. Tilf\xf8j mere, og pr\xf8v igen.",
    'fabric.editor.ai.experience.loadingAriaNewTitle': 'Analyserer',
    'fabric.editor.ai.experience.loadingAriaTitle': 'Genererer',
    'fabric.editor.ai.experience.loadingEditingTitle': 'Redigerer',
    'fabric.editor.ai.experience.previewScreenLabel': "Forh\xe5ndsvis",
    'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder': "Bed agenten om at skrive noget, eller v\xe6lg fra listen nedenfor",
    'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
    'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo-logo',
    'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
    'fabric.editor.ai.screens.discard.cancelLabel': 'Tilbage',
    'fabric.editor.ai.screens.discard.discardLabel': "Kass\xe9r",
    'fabric.editor.ai.screens.error.warningIconLabel': 'Advarsel',
    'fabric.editor.ai.screens.error.ariaErrorTitle': 'Fejl',
    'fabric.editor.ai.screens.error.cancelLabel': 'Annuller',
    'fabric.editor.ai.screens.error.retryLabel': "Pr\xf8v igen",
    'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Liveopdatering af indhold:',
    'fabric.editor.ai.screens.loading.iconAltText': 'Genererer ikon',
    'fabric.editor.ai.screens.preview.actionButtonsAccept': "Accept\xe9r",
    'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': 'Handlinger for indhold genereret af kunstig intelligens',
    'fabric.editor.ai.screens.preview.actionButtonsTryAgain': "Pr\xf8v igen",
    'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
    'fabric.editor.ai.screens.preview.cancelLabel': 'Annuller',
    'fabric.editor.ai.screens.preview.compactFeedbackText': 'Nyttigt?',
    'fabric.editor.ai.screens.preview.defaultAIPlaceholder': "Fort\xe6l AI, hvad der nu skal g\xf8res",
    'fabric.editor.ai.screens.preview.discardLabel': "Kass\xe9r",
    'fabric.editor.ai.screens.preview.disclaimer': 'Informationskvaliteten kan variere.',
    'fabric.editor.ai.screens.preview.disclaimerLink': "F\xe5 at vide hvorfor",
    'fabric.editor.ai.screens.preview.header.clear.hover': 'Ryd',
    'fabric.editor.ai.screens.preview.header.edit': 'Rediger prompt',
    'fabric.editor.ai.screens.preview.header.edit.hover': 'Rediger',
    'fabric.editor.ai.screens.preview.placeholderWithAgent': "Sp\xf8rg {agentName}, hvad der skal g\xf8res som det n\xe6ste",
    'fabric.editor.ai.screens.preview.refineButton': 'Tilpas',
    'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Tilpas',
    'fabric.editor.ai.screens.prompt.logoAltText': 'Atlassian Intelligence-logo',
    'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
    'fabric.editor.ai.screens.prompt.submitLabel': 'Send',
    'fabric.editor.ai.screens.prompt.submitTooltip': 'Send til AI',
    'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': "{promptName} \u2013 valgt",
    'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Fjern',
    'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Forslag',
    'fabric.editor.ai.shared.aiUniversalDescriptor': 'Skriveassistent',
    'fabric.editor.ai.shared.aiUniversalLongCallToAction': "Lad Atlassian Intelligence hj\xe6lpe dig med at skrive",
    'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Skriv',
    'fabric.editor.ai.shared.betaLabel': 'Beta',
    'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
    'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
    'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NY',
    'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Svar AI',
    'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': "Fort\xe6l agent"
};

});


//# sourceMappingURL=da.1c189b9c.js.map
